// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Hero__Wrapper_GzuV4","Title":"Hero__Title_2FO3G","Link":"Hero__Link_1Td2f","Facts":"Hero__Facts_1OQHf grid","Fact":"Hero__Fact_Zsabt","FactName":"Hero__FactName_4OfIB"};